import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface QuickBooks {

}

export default class QuickBooksRedirect extends React.Component<RouteComponentProps<{}>, QuickBooks> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.saveAuth();
    }

    async saveAuth() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get the query parameters
        const params = new URLSearchParams(window.location.search);
        var code = "";
        if (params.has('code')) {
            code = params.get('code') ?? "";
        };
        var realmId = "";
        if (params.has('realmId')) {
            state = params.get('realmId') ?? "";
        }
        var state = "";
        if (params.has('state')) {
            state = params.get('state') ?? "";
        }

        //decode state parameter
        var actual = JSON.parse(atob(state));

        //save the quick books code and realmid
        var authDetails = {
            code: code,
            realmId: realmId,
            subId: user.sub
        };

        if (code) {
            //save the quick books authentication details
            axios.post('api/Invoicing/SaveQuickBooksAuthentication', authDetails, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                //redirect to the appropriate page with the code and realmid paramerters
                var redirect = "/" + actual.page;
                if (actual.id) {
                    redirect += "/" + actual.id;
                }
                this.props.history.push(redirect);
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    render() {
        return <div>
            Redirecting...
        </div>;
    }
}